import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
	theme: {
		options: {
			customProperties: true, // Enable CSS variables for theme colors
		},
		themes: {
			light: {
				primary: '#018630',
				darkprimary: '#175E45',
				secondary: '#015347',
				darksecondary: '#003F6F',
				accent: '#616161',
				error: '#ff1327',
				success: '#4dd180',
				info: '#0000FF',
			},
		},
	},
})
